import React, { useState } from 'react'
import { Link } from 'react-router-dom'
//import { formatTel } from '@/components/form/input/tel-mask-input'
import { Mail, Phone, Linkedin, Facebook, ChevronUp } from 'lucide-react'
import { InstagramLogoIcon } from '@radix-ui/react-icons'
import bahiaLogo from './Images/Bahia/bahiaLogo.png'
import bahiaLading from './Images/Bahia/bahiaLading.svg'
import Divider from './Images/Bahia/Divider.svg'
import fundo from './Images/Bahia/fundo.png'
import Login from './Images/Bahia/Login.png'
import { ROUTES } from '@/config/routes'

const ServiceCard: React.FC<{ title: string }> = ({ title }) => (
  <div
    className="bg-[#ffff] text-black font-medium text-xs sm:text-sm 
      rounded-2xl w-full h-[160px] sm:h-[220px] 
      flex items-center justify-center text-center px-4 py-2 shadow-md"
  >
    {title}
  </div>
)

const Header: React.FC = () => (
  <header className="w-full">
    <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between px-4 py-3 gap-3">
      <Link to={ROUTES.HOME.path} className="shrink-0">
        <img src={bahiaLogo} alt="Bahia Sul Logo" className="w-24 sm:w-28 object-contain" />
      </Link>

      <div className="flex flex-wrap items-center justify-end gap-2 sm:gap-4 max-w-full shrink">
        <Link
          to={ROUTES.CONTACT.path}
          className="bg-[rgba(191,171,80,1)] border-2 border-[rgba(141,127,62,1)] text-white px-3 py-1.5 rounded-md text-xs sm:text-sm hover:brightness-90 transition"
        >
          Contato
        </Link>
        <Link
          to={ROUTES.SERVICES.path}
          className="bg-[rgba(191,171,80,1)] border-2 border-[rgba(141,127,62,1)] text-white px-3 py-1.5 rounded-md text-xs sm:text-sm hover:brightness-90 transition"
        >
          Serviços
        </Link>
        <button aria-label="Login/Menu" className="shrink-0">
          <img src={Login} alt="Menu" className="w-8 h-8 object-contain sm:w-10 sm:h-10" />
        </button>
      </div>
    </div>
  </header>
)

//Parte do contato
const ContactInfo: React.FC = () => (
  <div
    className="bg-[rgba(191,171,80,1)] flex flex-col md:flex-row items-start md:items-center justify-between 
text-xs text-white font-normal mt-6 px-6 py-4 rounded-2xl gap-4 md:gap-6 max-w-[400px] mx-auto w-full"
  >
    {' '}
    <a href="mailto:contato@bahiasul.com.br" className="flex items-center gap-2 text-white underline">
      <Mail className="w-7 h-7 shrink-0" />
      <span>contato@bahiasul.com.br</span>
    </a>
    <a href="tel:+553100000000" className="flex items-center gap-2 text-neutral-100">
      <Phone className="w-7 h-7 shrink-0" />
      <span>(31)0000-0000</span>
    </a>
  </div>
)

//Informações de Contato
const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    tel: '',
    email: '',
    message: ''
  })

  const [errors, setErrors] = useState({
    name: '',
    tel: '',
    email: '',
    message: ''
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))

    if (errors[name as keyof typeof errors]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  const validate = () => {
    let valid = true
    const newErrors = { ...errors }

    if (!formData.name.trim()) {
      newErrors.name = 'Nome é obrigatório'
      valid = false
    }

    if (!formData.tel.trim()) {
      newErrors.tel = 'Telefone é obrigatório'
      valid = false
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email é obrigatório'
      valid = false
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email inválido'
      valid = false
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Mensagem é obrigatória'
      valid = false
    }

    setErrors(newErrors)
    return valid
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (validate()) {
      console.log('Form submitted:', formData)
      alert('Mensagem enviada com sucesso!')

      setFormData({
        name: '',
        tel: '',
        email: '',
        message: ''
      })
    }
  }
  return (
    <form
      onSubmit={handleSubmit}
      className="bg-[rgba(141,127,62,1)]  w-full max-w-xl mx-auto flex flex-col text-sm text-white font-normal p-6 rounded-2xl"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex flex-col">
          <label htmlFor="name">Nome*</label>
          <input
            id="name"
            name="name"
            type="text"
            value={formData.name}
            onChange={handleChange}
            required
            className="bg-[rgba(217,217,217,0.26)] h-10 mt-1 rounded-xl px-3 text-white placeholder-white"
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="tel">Telefone*</label>
          <input
            id="tel"
            name="tel"
            type="tel"
            value={formData.tel}
            onChange={handleChange}
            required
            className="bg-[rgba(217,217,217,0.26)] h-10 mt-1 rounded-xl px-3 text-white placeholder-white"
          />
        </div>
      </div>

      <div className="flex flex-col mt-4">
        <label htmlFor="email">Email*</label>
        <input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          required
          className="bg-[rgba(217,217,217,0.26)] h-10 mt-1 rounded-xl px-3 text-white placeholder-white"
        />
      </div>

      <div className="flex flex-col mt-4">
        <label htmlFor="message">Mensagem*</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          className="bg-[rgba(217,217,217,0.26)] h-24 mt-1 rounded-xl px-3 py-2 text-white resize-none placeholder-white"
        />
      </div>

      <button
        type="submit"
        className="bg-[rgba(141,127,62,1)]  text-white font-medium mt-6 py-3 rounded-xl hover:bg-[#c4c8cc] transition-colors"
      >
        ENVIAR
      </button>
    </form>
  )
}

const BahiaSulPage: React.FC = () => {
  const services = [
    { id: 1, title: 'Assessoria tributária' },
    { id: 2, title: 'Assessoria Jurídica Tributária' },
    { id: 3, title: 'Consultoria' },
    { id: 4, title: 'Licitações' },
    { id: 5, title: 'Atendimento Personalizado' },
    { id: 6, title: 'Contabilidade' }
  ]

  return (
    <div className="bg-white flex flex-col overflow-hidden items-center">
      <section className="flex flex-col self-stretch relative min-h-[978px] items-center pt-[33px] pb-[265px] px-20 max-md:max-w-full max-md:mr-[3px] max-md:pb-[100px] max-md:px-5">
        <img src={bahiaLading} alt="Background" className="absolute h-full w-full object-cover inset-0" />
        <div className="relative mb-[-53px] w-full max-w-[1674px] max-md:max-w-full max-md:mb-2.5">
          <Header />
          <div className="flex w-[648px] max-w-full flex-col font-semibold mt-[171px] max-md:mt-10">
            <h1 className="text-[rgba(141,127,62,1)] text-3xl sm:text-4xl md:text-6xl font-extrabold leading-tight">
              Quer entender a <br className="hidden sm:block" />
              tributação da sua empresa?
            </h1>
            <p className="text-[rgba(64,58,32,1)] text-base sm:text-lg mt-4">
              Conte conosco para esclarecer e organizar cada detalhe e garantir uma gestão tributária segura!
            </p>

            <div className="mt-8 flex justify-center md:justify-start">
              <button
                className="bg-[rgba(191,171,80,1)] text-white font-semibold px-8 py-3 rounded-[10px] text-sm sm:text-base hover:brightness-90 transition"
                onClick={() => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })}
              >
                ENTRE EM CONTATO
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[rgba(237,235,227,1)] self-stretch w-full max-md:max-w-full">
        <div className="flex flex-col relative min-h-[1476px] items-center justify-center px-20 py-[170px] max-md:max-w-full max-md:px-5 max-md:py-[100px]">
          <img src={fundo} alt="Background" className="absolute h-full w-full object-cover inset-0" />
          <div className="relative flex mb-[-34px] w-[1234px] max-w-full flex-col items-stretch max-md:mb-2.5">
            <h2 className="text-[rgba(18,39,37,1)] text-2xl font-bold self-center ml-8">Áreas de Atuação</h2>

            <div className="ml-[11px] mt-[35px] max-md:max-w-full">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-x-3 gap-y-4 px-4 w-full max-w-5xl mx-auto">
                {services.map(service => (
                  <ServiceCard key={service.id} title={service.title} />
                ))}
              </div>
            </div>

            <section className="bg-[rgba(254,254,254,1)] flex flex-col text-black mt-[251px] pl-[29px] pr-20 py-[54px] rounded-[39px] max-md:max-w-full max-md:mt-10 max-md:px-5">
              <h2 className="text-2xl font-bold">Quem Somos?</h2>
              <div className="text-lg font-normal mt-[26px] max-md:max-w-full">
                Na Bahia Sul, simplificamos o universo da tributação para que você possa focar no que realmente importa:
                fazer sua empresa crescer de forma sustentável.
                <br />
                <br />
                Com muita experiência e uma equipe altamente qualificada, oferecemos soluções personalizadas que
                otimizam seus processos fiscais, asseguram conformidade legal e eliminam surpresas desagradáveis.Nosso
                compromisso é ser o parceiro estratégico que você precisa para lidar com questões tributárias de forma
                eficiente, prática e segura.
                <br />
                <br />
                Tem dúvidas ou quer saber mais? Entre em contato conosco agora mesmo. Estamos prontos para ajudar você a
                alcançar seus objetivos com tranquilidade e confiança.
                <br />
                <br />
              </div>
            </section>
          </div>
        </div>
      </section>

      <section className="flex flex-col items-center w-full">
        <img src={Divider} alt="Divider" className="aspect-[1.41] object-contain w-[86px]" />
        <h2 className="text-[#424242] text-2xl font-bold mt-[76px] max-md:mt-10">Contato</h2>

        <ContactInfo />

        <p className="text-black text-lg font-normal ml-3.5 mt-[75px] max-md:max-w-full max-md:mt-10">
          De segunda à sexta-feira das 09h00 às 18h00
          <br />
          ou entre em contato através do formulário abaixo.
        </p>

        <ContactForm />
      </section>

      <footer className="bg-[rgba(237,235,227,1)] w-full flex flex-col items-center px-6 py-10 mt-20">
        <h3 className="text-[rgba(18,39,36,1)]text-sm font-extrabold">SIGA-NOS</h3>

        <div className="flex flex-col md:flex-row items-center justify-center    gap-6 w-full max-w-4xl mt-6 text-[rgba(18,39,36,1)] text-xs font-medium text-center md:text-left">
          <div>
            Acompanhe a Bahia Sul nas
            <br /> redes sociais
          </div>

          <div className="flex items-center gap-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <Facebook className="w-8 h-8 hover:opacity-80 transition-opacity" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <InstagramLogoIcon className="w-8 h-8 hover:opacity-80 transition-opacity" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <Linkedin className="w-8 h-8 hover:opacity-80 transition-opacity" />
            </a>
          </div>
        </div>
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-6 right-6 z-50 text-[rgba(191,171,80,1)] text-black p-3 rounded-full shadow-lg hover:bg-[rgba(191,171,80,1)] transition-colors"
          aria-label="Voltar ao topo"
        >
          <ChevronUp className="w-5 h-5" />
        </button>
        <hr className="border-[rgba(18,39,36,1)] w-full max-w-4xl my-8" />

        <div className="flex  md:flex-row justify-between items-start gap-8 w-full max-w-4xl text-[rgba(18,39,36,1)]text-xs font-normal">
          <div className="flex items-start gap-4">
            <img src={bahiaLogo} alt="Bahia Sul Logo" className="w-12 object-contain" />
            <nav className="flex flex-col space-y-1">
              <a href="#" className="hover:underline">
                Home
              </a>
              <a href="#contact" className="hover:underline">
                Contato
              </a>
              <a href="#services" className="hover:underline">
                Serviços
              </a>
            </nav>
          </div>

          <address className="not-italic leading-relaxed">
            <div className="font-bold mb-1">Endereço</div>
            Rua xx
            <br />
            Belo Horizonte - MG
            <br />
            CEP: 31310-000, Brasil
          </address>
        </div>
      </footer>
    </div>
  )
}

export default BahiaSulPage
